import React from 'react';
import { useReactTable, getCoreRowModel, getSortedRowModel, flexRender } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import { generateColumn } from '../common';

interface ITwilioCallsByType {
  type: string;
  label: string;
  count: number;
}

interface TwilioCallsTableByTypeProps {
  data: ITwilioCallsByType[];
}

const TwilioCallsTableByType: React.FC<TwilioCallsTableByTypeProps> = ({ data }) => {
  const columns = React.useMemo<ColumnDef<any, unknown>[]>(
    () => [
      generateColumn('type', {
        customHeader: 'Type',
      }),
      generateColumn('label', {
        customHeader: 'Description',
      }),
      generateColumn('count', {
        customHeader: 'Call Count',
      }),
    ],
    []
  );

  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const adminStatsTableStyle = {
    thStyle: {
      borderBottom: 'solid 3px red',
      background: 'aliceblue',
      color: 'black',
      cursor: 'pointer',
      fontWeight: 'bold',
      verticalAlign: 'middle',
      textTransform: 'none',
    } as React.CSSProperties,
    tdStyle: {
      padding: '10px',
      border: 'solid 1px gray',
    } as React.CSSProperties,
  };

  return (
    <div>
      <h4>Calls by Type</h4>
      <table className="table">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={adminStatsTableStyle.thStyle}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  <div>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                    <span>
                      {header.column.getIsSorted()
                        ? header.column.getIsSorted() === 'desc'
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} style={adminStatsTableStyle.tdStyle}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TwilioCallsTableByType.displayName = 'TwilioCallsTableByType';

export default TwilioCallsTableByType;
